<template>
  <EFlightBooking />
</template>

<script>
export default {
  name: 'EFlightBookingWrapper',
  components: {
    EFlightBooking: async () => import(
      /* webpackChunkName: "flight-booking" */
      './widget.vue'
    ),
  },
};
</script>
